import { useState } from 'react';
import { Button, Icon } from '@iwoca/orion';
import clsx from 'clsx';
import { FundingRequirement } from './FundingRequirement';
import { TDeserialisedFundingRequirement } from './fundingRequirements.helper';
import styles from './FundingRequirementSection.module.css';

type TProps = {
  title: string;
  requirements: TDeserialisedFundingRequirement[];
};

export const FundingRequirementSection = ({ title, requirements }: TProps) => {
  const [isOpen, setIsOpen] = useState(true);

  const requirementsCompleted = requirements.filter(
    (requirement) => requirement.isCompleted,
  ).length;

  const toggleOpen = () => {
    setIsOpen((prevState) => !prevState);
  };

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <Button
          data-testid="toggle-button"
          className={styles.toggleButton}
          variant="tertiary"
          onClick={toggleOpen}
        >
          <span
            className={styles.toggleButtonLabel}
          >{`${title} (${requirementsCompleted}/${requirements.length})`}</span>
          <Icon
            className={clsx(styles.toggleButtonIcon, {
              [styles.toggleButtonIconOpen]: isOpen,
            })}
            icon="angleRight"
            height={24}
            width={24}
          />
        </Button>
      </div>
      {isOpen && (
        <ul className={styles.fundingRequirementList}>
          {requirements.map((requirement) => (
            <FundingRequirement
              key={requirement.type}
              requirement={requirement}
            />
          ))}
        </ul>
      )}
    </div>
  );
};
